import actions from './actions';
import events from './DemoEvents';
import { CALENDAR_TIMESTAMPS } from '../../constants/constants';

const initState = {
  events,
  view: CALENDAR_TIMESTAMPS.MONTH,
  availabilityView: CALENDAR_TIMESTAMPS.WEEK,
};

export default function calendarReducer(state = initState, action) {
  switch (action.type) {
    case actions.CALENDAR_VIEW:
      return {
        ...state,
        view: action.view,
      };
    case actions.CALENDAR_EVENTS:
      return {
        ...state,
        events: action.events,
      };
    case actions.CALENDAR_AVAILABILITY_VIEW:
      return {
        ...state,
        availabilityView: action.availabilityView,
      };
    default:
      return state;
  }
}
